export class AdTypeGroup {
    groupType: number;
    name: string;
    max: number;
    used: number;
    adTypes: AdType[];
}
export class AdType {
    type: number;
    name: string;
    sizeRequirement: string;
    constructor() {
        this.type = -1;
    }
}